<template>
    <div class="legend-box d-flex flex-column justify-content-center ms-4" :class="{ 'gap-md-5 gap-2': true }">
        <div v-for="item in legendItems" :key="item.key" class="d-flex align-items-center gap-2">
            <div
                class="legend-icon shrink-0"
                :class="[item.shape === 'circle' ? 'legend-circle' : 'legend-square']"
                :style="{ backgroundColor: item.color }"
            ></div>
            <span v-if="loading" class="placeholder-wave">
                <span class="placeholder legend-placeholder" :style="{ width: item.placeholderWidth || '80px' }"></span>
            </span>
            <span v-else>{{ item.text }}</span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    legendItems: {
        type: Array,
        required: true,
        // Each item should have: { key, text, color, shape: 'circle' | 'square', placeholderWidth?: string }
    },
    loading: {
        type: Boolean,
        default: false,
    },
});
</script>

<style scoped>
.legend-box {
    border-radius: 12px;
    border: 1px solid var(--Light-Grey, #e4e5e6);
    padding: 16px;
}

/* Desktop padding */
@media (min-width: 768px) {
    .legend-box {
        padding: 32px;
    }
}

.legend-icon {
    width: 12px;
    height: 12px;
}

.legend-circle {
    border-radius: 50%;
}

.legend-square {
    /* Square shape by default */
}

.legend-placeholder {
    height: 20px;
    border-radius: 4px;
}

/* Lighter placeholder color to match SkeletonLoader */
.placeholder {
    background-color: #f1f3f4 !important;
    opacity: 0.8;
}
</style>
